import type { SVGProps } from "react";

/** DC section-nav icons (12×12, stroke=currentColor) — mirror screen-02 эталон. */
const base = { viewBox: "0 0 12 12", fill: "none", stroke: "currentColor", strokeWidth: 1.6 } as const;

export const IcGrid = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><rect x="1" y="1" width="4" height="4" /><rect x="7" y="1" width="4" height="4" /><rect x="1" y="7" width="4" height="4" /><rect x="7" y="7" width="4" height="4" /></svg>
);
/** 29.10: «Новый год» — ёлка в два яруса со стволом */
export const IcNy = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p} strokeLinejoin="round"><path d="M6 1L2.6 5h2L2 8.6h8L7.4 5h2z" /><path d="M6 8.6V11" /></svg>
);
export const IcLeads = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><polygon points="6,1 11,6 6,11 1,6" /></svg>
);
export const IcCancel = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M2 2l8 8M10 2l-8 8" /></svg>
);
export const IcMirkv = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><rect x="1" y="2" width="10" height="8" /><path d="M1 5h10" /></svg>
);
export const IcBez = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><rect x="1" y="3" width="10" height="6" /></svg>
);
export const IcMoney = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><circle cx="6" cy="6" r="5" /><path d="M6 1v10" /></svg>
);
export const IcClients = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p} strokeLinecap="square"><circle cx="5" cy="4.5" r="2" /><path d="M2 11v-1a3 3 0 0 1 3-3h0" /><circle cx="8.5" cy="8" r="2" /><path d="M10 9.5l1.5 1.5" /></svg>
);
export const IcCommerce = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M6 1H2v4l5 5 4-4z" /><circle cx="4" cy="4" r="0.7" /></svg>
);
export const IcShop = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M2.4 4h7.2l-.7 6.4H3.1z" /><path d="M4.3 4a1.7 1.7 0 0 1 3.4 0" /></svg>
);
